<div class="employee-actions">
    <a *ngIf="hasClosedPeriod" href="javascript:void(0);" (click)="goToPayroll()" data-bs-toggle="tooltip"
        data-bs-placement="top" title="Nómina del colaborador">
        <img src="../../../../assets/img/icons/folder-shared-01.svg" alt="Nómina del colaborador" width="20" height="20">
    </a>
    <a *ngIf="canDo('Registrar incidencia')" href="javascript:void(0);" (click)="registerIncident()"
        data-bs-toggle="tooltip" data-bs-placement="top" title="Registrar incidencia">
        <img src="../../../../assets/img/icons/license-pin.svg" alt="Registrar incidencia" width="20" height="20">
    </a>
    <a *ngIf="canDo('Dar de baja')" href="javascript:void(0);" (click)="dischargeEmployee()" data-bs-toggle="tooltip"
        data-bs-placement="top" [class.is-disabled]="isTerminated" [title]="isTerminated ? 'Ya está dado de baja' : 'Dar de baja'">
        <img src="../../../../assets/img/icons/user-block-02.svg" alt="Dar de baja" width="20" height="20">
    </a>
</div>
